import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import axios from 'axios';

function Sales() {

    const [sales, setSales] = useState({
        "name": "Anirudha",
        "mobile": "7350364321",
        "product": "mobile",
        "price": "1000",
        "quantity": "2",
        "gst": "18",
        "total": ""
      });

    const [data, setData] = useState([]);

    useEffect(() => {
        loadData();
    }, [])

    function loadData() {
        // e.preventDefault()
        axios.get("https://653cb488d5d6790f5ec82dfd.mockapi.io/api/v1/sales")
            .then((res) => {
                setData(res.data);
                // console.log(res.data)
            })
    }



    return (
        <main id="main" className="main">
            <div className="pagetitle d-flex justify-content-between align-items-center">
                <div>
                    <h1>Sales</h1>
                </div>
                <Link to='/admin/sale'>
                    <button type="button" className="btn btn-primary">Add</button>
                </Link>

            </div>
            <div className="card">
                <div className="card-body ">

                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col">Action</th>
                                <th scope="col">No</th>
                                <th scope="col">Name</th>
                                <th scope="col">Mobile</th>
                                <th scope="col">Subtotal</th>
                                <th scope="col">GST Total</th>
                                <th scope="col">Bill Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data.map((item, i) => {

                                    return (
                                        <tr key={i}>
                                            <th>
                                                <div className='d-flex justify-content-start align-items-center gap-2'>
                                                    <button className='btn btn-primary btn-sm'>Edit</button>
                                                    <button className='btn btn-danger btn-sm'>Delete</button>
                                                    <Link to={"/admin/print/" + item.id} className='btn btn-success btn-sm'>Print</Link>
                                                </div>
                                            </th>
                                            <th scope="row" id='index'>{i + 1}</th>
                                            <td>{item.name}</td>
                                            <td >{item.mobile}</td>
                                            <td>{item.subtotal}.00</td>
                                            <td>{item.gstamount}.00</td>
                                            <td>{item.billamount }.00</td>

                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                    <div className='d-flex justify-content-end'>
                        <Link to="/admin/print" className='btn btn-success btn-'>Print</Link>
                    </div>
                </div>
            </div>
                            
        </main>


    )
}

export default Sales